// biome-ignore assist/source/organizeImports: off
import { motion } from 'framer-motion';
import { Navigate } from 'react-router-dom';

import Card from '../../components/Card';
import { titleSection, btnRightSection } from '../../animations/PageAnimations';
import { useAppSelector } from '../../hooks';
import { selectSectionById } from '../../store/WebSettingsSlice';
import { openWebView } from '../../utils/NativeWebView';

const Home = () => {

  const appSettings = window.appSettings;
  const deviceID = window.deviceID || 'browser';

  const showNewSection = appSettings?.branch === "11";

  const ID_SECTION = showNewSection ? 'home-open-account' : 'home';

  const section = useAppSelector(state => selectSectionById(state, ID_SECTION));

  if (deviceID && appSettings?.status !== 'ok') {
  // if (appSettings?.status !== 'ok') {
    return <Navigate to="/settings" />;
  }

  const handleClick = () => {
    const link = section?.linkBtnScheduleAppointment || "";
    openWebView(link);
  };

  return (
    <section className="relative mx-auto px-12 py-8">
      <motion.h1
        initial="initial"
        animate="animate"
        exit="exit"
        variants={titleSection}
        key="title-home"
        className="mt-1 xl:mt-6 font-bold"
        // biome-ignore lint/security/noDangerouslySetInnerHtml: off
        dangerouslySetInnerHTML={{__html: section?.title || ''}}
      />

      { showNewSection &&
        <motion.div className="font-semibold text-lg absolute top-16 right-16 inline-flex items-center rounded-full bg-orange text-white px-6 py-3"
          onClick={handleClick}
          key="btn-schedule-appointment"
          initial="initial"
          animate="animate"
          exit="exit"
          variants={btnRightSection}
          whileTap={{ scale: 0.95 }}
        >
          <span>{section?.textBtnScheduleAppointment}</span>
        </motion.div>
      }

      <motion.div
        key="content-home"
        initial="initial"
        animate="animate"
        exit="exit"
        className="mt-8 xl:mt-12 grid grid-cols-2 gap-4 xl:gap-8"
      >
        {section?.cards?.map((card, index) =>
          (
            <Card
              {...card}
              index={index + 1}
              key={card.id}
              // id={card.id}
              // type={card.type}
              // image={card.image}
              // link={card.link}
              // title={card.title}
              // description={card.description}
            />
          )
        )}
      </motion.div>
    </section>
  );
};

export default Home;
